import React from 'react';

const Trope3: React.FC = () => {
  return (
    <g
      className="prefix__trope-decor-3 prefix__trope-decor"
      transform="translate(200, 210)"
    >
      <path
        d="M374.32,126.71s45.09-25,68.66-24.66c47.34.66,78.67,22,78.67,22s-20-26.68,2.67-30,12.66-26.67-4-40.67S479,14.71,429,29.38c-38.91,11.41-53.33,24.67-53.33,24.67S360.71,62.3,361.59,70.5c2,18.5,21.92,10.6,21.06,17-.66,4.93-11.28,13.26-12.5,19A26,26,0,0,0,374.32,126.71Z"
        fill="#f1ce58"
      />
      <ellipse
        cx="367"
        cy="70.98"
        rx="5.43"
        ry="2"
        transform="translate(-6.32 90) rotate(-13.86)"
        fill="#e1a554"
      />
      <path
        d="M369.8,69.43c.49,2-1.39,2.58-4,3.23s-5,1.1-5.49-.88a5.5,5.5,0,0,1,3.69-6C366.61,65.17,369.31,67.44,369.8,69.43Z"
        fill="#eebf57"
      />
      <path
        d="M366.55,66a4.49,4.49,0,0,1,.92,1.71c.49,2-1.39,2.58-4,3.23a14.92,14.92,0,0,1-3.2.55,2.34,2.34,0,0,0,0,.26c.49,2,2.86,1.53,5.49.88s4.51-1.25,4-3.23A5.45,5.45,0,0,0,366.55,66Z"
        fill="#d6974f"
      />
      <path
        d="M455.65,64.05a21.41,21.41,0,0,0-21-2.5c-8.5,3.5-17.5,9.5-22,10.5s-14.5,3.5-14.5,10,14.5,8.5,25,3,29.5-3.5,35.5-4.5S459.15,66.55,455.65,64.05Z"
        fill="#eebf57"
      />
      <path
        d="M508.65,72.05c-13.69-6.23-23-7-31.5-5.5s-9.5,6.5-5,12.5,17,4,30,9.5,22.5,9,24,1S514.15,74.55,508.65,72.05Z"
        fill="#eebf57"
      />
      <path
        d="M358.32,102.05c8.11-.6,13.83-2.5,22.33-5.5s16-9.5,13.5-15.5-29-1.5-37.5,4.5S351.48,102.55,358.32,102.05Z"
        fill="#eebf57"
      />
      <path
        d="M429.15,34.38c-6.19-3-29.33,3.17-35.83,7.67s-17.67,13.33-17.17,23.33,24.5-3,35.5-5.5S444.65,41.88,429.15,34.38Z"
        fill="#eebf57"
      />
      <path
        d="M490.65,36.55a77.68,77.68,0,0,0-37.5-4.5c-11.5,1.5-13.5,9-13,15.5s10,4.5,18.5,5.5,40,6,38,0S495.65,38.55,490.65,36.55Z"
        fill="#eebf57"
      />
      <ellipse
        cx="527.2"
        cy="77.54"
        rx="2"
        ry="5.43"
        transform="translate(314.55 566.14) rotate(-74.85)"
        fill="#e1a554"
      />
      <path
        d="M530.41,77.53c-.54,2-2.48,1.59-5.09.88S520.42,77,521,75a5.49,5.49,0,0,1,6.11-3.41C529.68,72.26,530.94,75.56,530.41,77.53Z"
        fill="#eebf57"
      />
      <path
        d="M529.21,73a4.46,4.46,0,0,1,0,1.93c-.54,2-2.48,1.59-5.09.88A15.28,15.28,0,0,1,521,74.73,2.34,2.34,0,0,0,521,75c-.53,2,1.76,2.73,4.37,3.44s4.55,1.1,5.09-.88A5.47,5.47,0,0,0,529.21,73Z"
        fill="#d6974f"
      />
      <ellipse cx="469.48" cy="63.21" rx="4.54" ry="1.67" fill="#e1a554" />
      <path
        d="M472.07,62.51c0,1.7-1.65,1.81-3.91,1.81s-4.27-.11-4.27-1.81a4.58,4.58,0,0,1,4.18-4.09A4.4,4.4,0,0,1,472.07,62.51Z"
        fill="#eebf57"
      />
      <path
        d="M470.11,59.1a3.67,3.67,0,0,1,.41,1.57c0,1.7-1.65,1.82-3.91,1.82a13,13,0,0,1-2.71-.2,1.62,1.62,0,0,0,0,.22c0,1.7,2,1.81,4.27,1.81s3.91-.11,3.91-1.81A4.6,4.6,0,0,0,470.11,59.1Z"
        fill="#d6974f"
      />
      <path
        d="M429.15,34.38a8.08,8.08,0,0,0-2.34-.63c6.67,8-11.67,20.42-21.41,22.63-7.55,1.72-21.23,8.38-29.23,9.16.76,9.69,24.54-3.17,35.48-5.66S444.65,41.88,429.15,34.38Z"
        fill="#e1a554"
      />
      <path
        d="M496.65,53.05c-1.5-4.51-1.31-10.42-3.24-13.93.58,3.18-.48,6.63-4.76,9.18-5.44,3.23-27,2-35.5,1-5.16-.61-9.95-.77-13-2.24l0,.49c.5,6.5,10,4.5,18.5,5.5S498.65,59.05,496.65,53.05Z"
        fill="#e1a554"
      />
      <path
        d="M394.15,81.05c-.53-1.28-2.15-2.07-4.44-2.49a2.62,2.62,0,0,1,.27.49c2.5,6-5,12.5-13.5,15.5s-14.21,4.9-22.33,5.5c-.21,0-.42,0-.62,0a5.71,5.71,0,0,0,4.79,2c8.11-.6,13.83-2.5,22.33-5.5S396.65,87.05,394.15,81.05Z"
        fill="#e1a554"
      />
      <polygon
        points="14.41 67.39 9.78 64.99 4.59 65.46 7 60.83 6.53 55.64 11.15 58.05 16.34 57.58 13.94 62.2 14.41 67.39"
        fill="#fff"
      />
      <path
        d="M455.65,64.05c-.36-.26-.74-.51-1.13-.76,2.51,4.76,4.07,11.55-.2,12.26-6,1-25-1-35.5,4.5-6.92,3.62-15.57,4-20.67,2v0c0,6.5,14.5,8.5,25,3s29.5-3.5,35.5-4.5S459.15,66.55,455.65,64.05Z"
        fill="#e1a554"
      />
      <ellipse cx="431.03" cy="59.7" rx="2.61" ry="0.96" fill="#e1a554" />
      <path
        d="M432.73,58.65c0,1-1,1-2.25,1s-2.45-.06-2.45-1a2.63,2.63,0,0,1,2.4-2.35A2.53,2.53,0,0,1,432.73,58.65Z"
        fill="#eebf57"
      />
      <path
        d="M431.6,56.69a2.13,2.13,0,0,1,.24.9c0,1-.95,1-2.25,1a7.28,7.28,0,0,1-1.55-.11.57.57,0,0,0,0,.13c0,1,1.15,1,2.45,1s2.25-.06,2.25-1A2.63,2.63,0,0,0,431.6,56.69Z"
        fill="#d6974f"
      />
      <path
        d="M525.88,86c-1.78,7.39-11.16,3.93-23.9-1.46-13-5.5-25.5-3.5-30-9.5a14.87,14.87,0,0,1-2.2-4c-.76,2.19.11,5,2.37,8,4.5,6,17,4,30,9.5s22.5,9,24,1A7,7,0,0,0,525.88,86Z"
        fill="#e1a554"
      />
      <path
        d="M193.52,91.71c1.15,5.05-9.73,9.38-23,12.41s-23.92,4-25.07-1.09S153.51,91,166.81,88,192.37,86.66,193.52,91.71Z"
        fill="#f1ce58"
      />
      <path
        d="M253.65,96c0,5-11.45,6.74-25,6.74s-24-1.39-24-6.39,10.45-9.58,24-9.58S253.65,91,253.65,96Z"
        fill="#f1ce58"
      />
      <path
        d="M343.65,100.37c0,6.68-15.29,9-33.33,9s-32-1.86-32-8.53,14-12.8,32-12.8S343.65,93.7,343.65,100.37Z"
        fill="#f1ce58"
      />
      <path
        d="M711.31,70.26c2.71,4.9-7.57,12.83-20.82,20.16s-24.26,11.64-27,6.74,5-15.07,18.31-22.41S708.59,65.36,711.31,70.26Z"
        fill="#f1ce58"
      />
      <path
        d="M791.9,34.78c2.76,5.83-4.76,11.88-14.76,16.61s-18.52,6.77-21.27.94,2.45-14.84,12.45-19.57S789.14,29,791.9,34.78Z"
        fill="#f1ce58"
      />
      <path
        d="M793.92,3.93c2.4,4.73-3.66,9.87-11.78,14s-15.08,6-17.47,1.22,1.7-12.25,9.83-16.36S791.53-.81,793.92,3.93Z"
        fill="#f1ce58"
      />
      <path
        d="M718,105.31c2.49,5.74-8.67,12.94-22.86,19.07s-25.85,9.28-28.33,3.54S673,112.17,687.21,106,715.52,99.57,718,105.31Z"
        fill="#f1ce58"
      />
      <path
        d="M718.35,105.12c-1-2.39-4.09-3.72-8.32-4a4.82,4.82,0,0,1,1.49,1.89c2.48,5.75-8.67,13-22.86,19.08-8.32,3.59-15.78,6.16-21,6.51,3.27,4.54,14.43,1.42,27.85-4.38C709.68,118.07,720.83,110.87,718.35,105.12Z"
        fill="#e1a554"
      />
      <path
        d="M1196.52,253.09c-3.34-1.55-4.86-10.68-1-18.93s11.34-12.6,14.68-11,3.43,9.36-.4,17.61S1199.86,254.65,1196.52,253.09Z"
        fill="#f1ce58"
      />
      <path
        d="M1213.83,254.6c-3.36-2.37-3.21-12.73,2.67-21s15-11.6,18.37-9.22,1.91,11-4,19.31S1217.2,257,1213.83,254.6Z"
        fill="#f1ce58"
      />
      <path
        d="M1188.68,281.49c-2.59-2.62-.83-11.71,5.63-18.11s15-7.87,17.61-5.25,0,10-6.51,16.37S1191.27,284.11,1188.68,281.49Z"
        fill="#f1ce58"
      />
      <path
        d="M1164.68,284.15c-2.59-2.61-.83-11.7,5.63-18.1s15-7.87,17.61-5.25,0,10-6.51,16.36S1167.27,286.77,1164.68,284.15Z"
        fill="#f1ce58"
      />
      <path
        d="M1179,317.82c-2.59-2.62-.84-11.71,5.63-18.11s15-7.87,17.6-5.25,0,10-6.5,16.37S1181.61,320.44,1179,317.82Z"
        fill="#f1ce58"
      />
      <path
        d="M1151.35,315.49c-2.59-2.62-.84-11.71,5.63-18.11s15-7.87,17.6-5.25,0,10-6.5,16.37S1153.94,318.11,1151.35,315.49Z"
        fill="#f1ce58"
      />
      <path
        d="M1035,383.51c-.72-5.06,8.75-13.75,21.24-15.54s23.24,3.64,24,8.7-8.28,11.08-20.77,12.87S1035.76,388.57,1035,383.51Z"
        fill="#f1ce58"
      />
      <path
        d="M1034.51,407.7c-.53-3.64,6.3-9.9,15.3-11.19s16.75,2.62,17.27,6.26-6,8-15,9.28S1035,411.35,1034.51,407.7Z"
        fill="#f1ce58"
      />
      <path
        d="M664,110c-.27,6.67-15.64,8.39-33.67,7.68s-31.9-3.13-31.63-9.8S613.17,95.69,631.2,96.4,664.28,103.37,664,110Z"
        fill="#f1ce58"
      />
      <path
        d="M345.52,123.39c0,5.43-12.42,7.32-27.08,7.32s-26-1.51-26-6.93,11.34-10.4,26-10.4S345.52,118,345.52,123.39Z"
        fill="#f1ce58"
      />
      <path
        d="M285,118.37c0,6.68-15.29,9-33.33,9s-32-1.86-32-8.53,14-12.8,32-12.8S285,111.7,285,118.37Z"
        fill="#f1ce58"
      />
      <path
        d="M58.27,80.49C53.65,88.67,38.72,84,23,75.11s-26.57-18-21.95-26.2,21-8.8,36.72.09S62.89,72.32,58.27,80.49Z"
        fill="#f1ce58"
      />
      <path
        d="M59.86,112.28c-3.09,7.37-16.17,4.92-30.33-1S5.27,98.7,8.36,91.33s16.87-9.54,31-3.61S62.94,104.91,59.86,112.28Z"
        fill="#f1ce58"
      />
      <path
        d="M332.86,115c1.7,1.29,2.66,2.74,2.66,4.25,0,5.42-12.42,7.32-27.08,7.32a110.91,110.91,0,0,1-15.46-.88c2.41,3.89,12.67,5,25.46,5,14.66,0,27.08-1.89,27.08-7.32C345.52,119.91,340.4,116.78,332.86,115Z"
        fill="#e1a554"
      />
      <path
        d="M328.71,90.21c2,1.71,3.18,3.61,3.18,5.59,0,7.12-14.82,9.61-32.3,9.61a120,120,0,0,1-18.44-1.15c2.88,5.11,15.11,6.62,30.36,6.62,17.49,0,32.31-2.49,32.31-9.61C343.82,96.7,337.7,92.58,328.71,90.21Z"
        fill="#e1a554"
      />
      <path
        d="M269.54,107.71c2,1.71,3.18,3.61,3.18,5.59,0,7.12-14.82,9.61-32.3,9.61A120,120,0,0,1,222,121.76c2.88,5.11,15.12,6.62,30.37,6.62,17.48,0,32.3-2.49,32.3-9.61C284.65,114.2,278.54,110.08,269.54,107.71Z"
        fill="#e1a554"
      />
      <path
        d="M242.21,88.21c1.58,1.27,2.48,2.68,2.48,4.15,0,5.28-11.55,7.13-25.17,7.13a97.43,97.43,0,0,1-14.37-.86c2.24,3.8,11.78,4.92,23.66,4.92,13.63,0,25.17-1.85,25.17-7.13C254,93,249.22,90,242.21,88.21Z"
        fill="#e1a554"
      />
      <g>
        <path
          d="M214.5,116c.84,4.91-10.1,8.56-23.37,10.85s-23.76,2.7-24.61-2.21,8.64-11.18,21.9-13.47S213.65,111.09,214.5,116Z"
          fill="#f1ce58"
        />
        <path
          d="M202.59,110.61c1.76.9,2.87,2,3.11,3.39.84,4.86-10.29,8.52-23.76,10.85a104.89,104.89,0,0,1-14.34,1.67c2.82,3.1,12.43,2.5,24.18.47,13.47-2.32,24.59-6,23.75-10.85C215,113,209.8,111,202.59,110.61Z"
          fill="#e1a554"
        />
      </g>
      <path
        d="M180.94,87c1.84.84,3,2,3.35,3.37,1.14,5-9.91,9.37-23.42,12.44a103.17,103.17,0,0,1-14.44,2.43c3,3.09,12.74,2,24.53-.68,13.51-3.07,24.56-7.42,23.42-12.44C193.65,88.88,188.27,87.05,180.94,87Z"
        fill="#e1a554"
      />
      <g>
        <path
          d="M113.83,141.93c1.31,7.67-10.73,12.48-25.48,15s-26.51,2.32-27.81-5.35,8.9-16.66,23.64-19.17S112.52,134.26,113.83,141.93Z"
          fill="#f1ce58"
        />
        <path
          d="M98.27,133.41a8.25,8.25,0,0,1,4.07,4.92c1.82,7.13-9.88,12.76-24.43,16.47-5.81,1.48-11.17-1.4-15.64-1.16,3.7,4.51,14.27,7.34,27,4.11,14.55-3.71,26.25-9.34,24.43-16.47C112.5,136.7,106.36,133.87,98.27,133.41Z"
          fill="#e1a554"
        />
      </g>
      <g>
        <path
          d="M154.38,134c.72,4.22-5.89,6.85-14,8.23s-14.55,1.27-15.27-2.94,4.89-9.14,13-10.51S153.67,129.77,154.38,134Z"
          fill="#f1ce58"
        />
        <path
          d="M145.84,129.31a4.55,4.55,0,0,1,2.24,2.7c1,3.91-5.42,7-13.41,9-3.19.81-6.13-.77-8.58-.64,2,2.48,7.83,4,14.79,2.26,8-2,14.41-5.13,13.41-9C153.65,131.11,150.29,129.56,145.84,129.31Z"
          fill="#e1a554"
        />
      </g>
      <g>
        <path
          d="M50.46,148c1.92,3.81-3.62,8.28-10.94,12s-13.54,5.5-15.46,1.69,2-10.17,9.31-13.87S48.54,144.18,50.46,148Z"
          fill="#f1ce58"
        />
        <path
          d="M40.92,146A4.55,4.55,0,0,1,43.85,148c2.11,3.45-3.12,8.29-10.15,12.59-2.81,1.71-6.09,1.07-8.39,1.92,2.66,1.77,8.66,1.54,14.8-2.2,7-4.3,12.26-9.14,10.16-12.59C48.92,145.47,45.24,145,40.92,146Z"
          fill="#e1a554"
        />
      </g>
      <g>
        <path
          d="M146.7,112.08c1.15,6.74-9.44,11-22.4,13.17s-23.31,2-24.46-4.7,7.83-14.64,20.79-16.85S145.55,105.33,146.7,112.08Z"
          fill="#f1ce58"
        />
        <path
          d="M133,104.59a7.3,7.3,0,0,1,3.58,4.32c1.6,6.27-8.69,11.22-21.48,14.48-5.11,1.3-9.83-1.23-13.75-1,3.25,4,12.54,6.44,23.7,3.6,12.79-3.26,23.08-8.21,21.48-14.48C145.53,107.48,140.13,105,133,104.59Z"
          fill="#e1a554"
        />
      </g>
      <g>
        <path
          d="M88.76,118.15c.56,3.27-4.57,5.32-10.86,6.39s-11.31,1-11.86-2.28,3.79-7.1,10.08-8.17S88.21,114.88,88.76,118.15Z"
          fill="#f1ce58"
        />
        <path
          d="M82.13,114.52a3.52,3.52,0,0,1,1.73,2.09c.78,3-4.21,5.44-10.41,7-2.48.64-4.77-.59-6.67-.49,1.57,1.93,6.08,3.13,11.49,1.75,6.21-1.58,11.2-4,10.42-7C88.2,115.92,85.58,114.71,82.13,114.52Z"
          fill="#e1a554"
        />
      </g>
      <path
        d="M53.89,63.23a10.4,10.4,0,0,1,0,7.59C50.41,79,36.16,76.18,20.8,69.54A88.71,88.71,0,0,1,5.17,61.23c0,6.93,10,13.3,23.41,19.09C43.94,87,58.19,89.74,61.71,81.6,64,76.37,60.63,69.35,53.89,63.23Z"
        fill="#e1a554"
      />
      <ellipse
        cx="271.06"
        cy="98.95"
        rx="2"
        ry="5.43"
        transform="translate(169.8 369.15) rotate(-89.51)"
        fill="#e1a554"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        d="M274.16,98.13c0,2.05-2,2.16-4.7,2.14s-5.12-.18-5.1-2.22a5.51,5.51,0,0,1,5.05-4.86C272.11,93.22,274.17,96.09,274.16,98.13Z"
        fill="#eebf57"
      />
      <path
        d="M271.85,94a4.53,4.53,0,0,1,.47,1.88c0,2-2,2.16-4.7,2.13a15.07,15.07,0,0,1-3.24-.26,2.28,2.28,0,0,0,0,.26c0,2,2.39,2.2,5.1,2.22s4.68-.09,4.7-2.14A5.47,5.47,0,0,0,271.85,94Z"
        fill="#d6974f"
      />
      <ellipse
        cx="291.9"
        cy="115.48"
        rx="1.5"
        ry="4.08"
        transform="translate(173.94 406.38) rotate(-89.51)"
        fill="#e1a554"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        d="M294.23,114.87c0,1.53-1.5,1.62-3.53,1.6s-3.84-.13-3.82-1.67a4.12,4.12,0,0,1,3.79-3.64A4,4,0,0,1,294.23,114.87Z"
        fill="#eebf57"
      />
      <path
        d="M292.5,111.8a3.4,3.4,0,0,1,.35,1.4c0,1.54-1.5,1.62-3.53,1.61a11.81,11.81,0,0,1-2.43-.2c0,.07,0,.13,0,.19,0,1.54,1.79,1.65,3.82,1.67s3.51-.07,3.53-1.6A4.1,4.1,0,0,0,292.5,111.8Z"
        fill="#d6974f"
      />
      <ellipse
        cx="197.45"
        cy="102.49"
        rx="1.71"
        ry="4.65"
        transform="matrix(0.01, -1, 1, 0.01, 93.28, 299.06)"
        fill="#e1a554"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        d="M200.1,101.8c0,1.74-1.7,1.84-4,1.82s-4.37-.15-4.36-1.9A4.71,4.71,0,0,1,196,97.57,4.5,4.5,0,0,1,200.1,101.8Z"
        fill="#eebf57"
      />
      <path
        d="M198.13,98.29a3.85,3.85,0,0,1,.4,1.61c0,1.75-1.71,1.85-4,1.83a12.8,12.8,0,0,1-2.77-.23,1.8,1.8,0,0,0,0,.22c0,1.75,2.05,1.88,4.36,1.9s4-.08,4-1.82A4.7,4.7,0,0,0,198.13,98.29Z"
        fill="#d6974f"
      />
      <ellipse
        cx="350.02"
        cy="115.14"
        rx="1.32"
        ry="3.6"
        transform="translate(231.89 464.16) rotate(-89.51)"
        fill="#e1a554"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        d="M352.07,114.6c0,1.36-1.32,1.43-3.11,1.42s-3.39-.12-3.38-1.47a3.64,3.64,0,0,1,3.34-3.22A3.5,3.5,0,0,1,352.07,114.6Z"
        fill="#eebf57"
      />
      <path
        d="M350.54,111.89a3,3,0,0,1,.31,1.24c0,1.36-1.32,1.43-3.11,1.42a10.65,10.65,0,0,1-2.15-.17c0,.05,0,.11,0,.17,0,1.35,1.58,1.45,3.38,1.47s3.1-.06,3.11-1.42A3.63,3.63,0,0,0,350.54,111.89Z"
        fill="#d6974f"
      />
      <path
        d="M657.67,102.22a4,4,0,0,1,0,.49c-.26,6.67-15.63,8.39-33.66,7.68-10.89-.44-20.25-1.49-25.91-3.72a5.7,5.7,0,0,0-.06.58c-.27,6.68,13.61,9.09,31.64,9.8s33.4-1,33.66-7.68C663.45,106.83,661.33,104.36,657.67,102.22Z"
        fill="#e1a554"
      />
      <path
        d="M705,67.6c1.71,4.94-8.29,12.55-21.06,19.61-8.34,4.62-15.78,8-20.83,8.71a4.06,4.06,0,0,0,.43,1.24c2.72,4.9,13.72.59,27-6.74S714,75.16,711.31,70.26C710.36,68.55,708.09,67.69,705,67.6Z"
        fill="#e1a554"
      />
      <path
        d="M765.3,73.37c2.44,5-8.26,12.4-21.9,19s-24.86,10.29-27.3,5.24S722,82.83,735.61,76.24,762.86,68.33,765.3,73.37Z"
        fill="#f1ce58"
      />
      <path
        d="M759.12,70.37c1.44,5-9,12.07-22.11,18.43-8.57,4.14-16.2,7.14-21.28,7.54a4.08,4.08,0,0,0,.37,1.26c2.44,5.05,13.67,1.35,27.3-5.24s24.34-13.94,21.9-19C764.45,71.61,762.23,70.63,759.12,70.37Z"
        fill="#e1a554"
      />
      <path
        d="M791.9,34.78c-1.4-3-4.91-4.66-9.33-5a6.8,6.8,0,0,1,1.52,2.06c2.76,5.83-4.76,11.87-14.76,16.61-4.92,2.32-9.46,4-13.15,4.4,3,5.13,11.29,3.1,21-1.48C787.14,46.66,794.66,40.61,791.9,34.78Z"
        fill="#e1a554"
      />
      <g>
        <path
          d="M830.73,53.72c1.43,6.3-7.22,10.57-18,13s-19.54,2.6-21-3.7,5.62-14,16.41-16.4S829.3,47.43,830.73,53.72Z"
          fill="#f1ce58"
        />
        <path
          d="M830.73,53.72c-.73-3.2-3.78-5.61-8-6.89a7.09,7.09,0,0,1,1,2.34c1.43,6.29-7.22,10.57-18,13-5.3,1.21-10.1,1.85-13.79,1.45,1.85,5.67,10.35,5.47,20.78,3.1C823.51,64.29,832.16,60,830.73,53.72Z"
          fill="#e1a554"
        />
      </g>
      <g>
        <path
          d="M835,18.07c1.43,6.29-7.22,10.56-18,13s-19.54,2.59-21-3.7,5.62-14,16.41-16.41S833.59,11.78,835,18.07Z"
          fill="#f1ce58"
        />
        <path
          d="M835,18.07c-.73-3.21-3.78-5.62-8-6.89a7,7,0,0,1,1,2.34c1.43,6.29-7.22,10.56-18,13-5.3,1.2-10.1,1.84-13.79,1.44,1.85,5.67,10.35,5.47,20.78,3.11C827.8,28.63,836.45,24.36,835,18.07Z"
          fill="#e1a554"
        />
      </g>
      <g>
        <path
          d="M752,55.16c1.43,6.29-7.22,10.57-18,13s-19.54,2.59-21-3.7,5.62-13.95,16.41-16.4S750.54,48.87,752,55.16Z"
          fill="#f1ce58"
        />
        <path
          d="M752,55.16c-.73-3.2-3.78-5.61-8-6.89a7,7,0,0,1,1,2.34c1.43,6.29-7.22,10.56-18,13-5.3,1.2-10.1,1.84-13.79,1.45,1.85,5.66,10.35,5.47,20.78,3.1C744.75,65.73,753.4,61.45,752,55.16Z"
          fill="#e1a554"
        />
      </g>
      <path
        d="M793.92,3.93A7.14,7.14,0,0,0,789.16.48a5.6,5.6,0,0,1,.76,1.11c2.4,4.74-3.66,9.87-11.78,14-5.17,2.62-9.87,4.31-13.21,4,2.59,4.18,9.34,2.33,17.21-1.64C790.26,13.8,796.32,8.66,793.92,3.93Z"
        fill="#e1a554"
      />
      <ellipse
        cx="649.15"
        cy="93.23"
        rx="1.5"
        ry="4.08"
        transform="translate(550.38 741.56) rotate(-89.51)"
        fill="#e1a554"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        d="M651.48,92.62c0,1.53-1.5,1.62-3.53,1.6s-3.84-.13-3.82-1.67a4.12,4.12,0,0,1,3.79-3.64A4,4,0,0,1,651.48,92.62Z"
        fill="#eebf57"
      />
      <path
        d="M649.75,89.55a3.4,3.4,0,0,1,.35,1.4c0,1.54-1.5,1.62-3.53,1.61a11.81,11.81,0,0,1-2.43-.2c0,.07,0,.13,0,.19,0,1.54,1.79,1.65,3.82,1.67s3.52-.07,3.53-1.6A4.1,4.1,0,0,0,649.75,89.55Z"
        fill="#d6974f"
      />
      <ellipse
        cx="756.52"
        cy="9.91"
        rx="4.08"
        ry="1.5"
        transform="translate(64.61 315.98) rotate(-24.61)"
        fill="#e1a554"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        d="M758.37,8.37c.64,1.39-.67,2.1-2.51,3s-3.53,1.51-4.17.11a4.13,4.13,0,0,1,1.88-4.91A4,4,0,0,1,758.37,8.37Z"
        fill="#eebf57"
      />
      <path
        d="M755.5,6.32a3.27,3.27,0,0,1,.91,1.13c.64,1.39-.66,2.1-2.51,3a11.83,11.83,0,0,1-2.28.85,1.34,1.34,0,0,0,.07.18c.64,1.4,2.32.73,4.17-.11s3.15-1.56,2.51-3A4.11,4.11,0,0,0,755.5,6.32Z"
        fill="#d6974f"
      />
      <ellipse
        cx="766.77"
        cy="27.66"
        rx="4.08"
        ry="1.5"
        transform="translate(58.15 321.86) rotate(-24.61)"
        fill="#e1a554"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        d="M768.62,26.12c.64,1.39-.67,2.1-2.51,2.95s-3.53,1.51-4.17.11a4.13,4.13,0,0,1,1.88-4.91A4,4,0,0,1,768.62,26.12Z"
        fill="#eebf57"
      />
      <path
        d="M765.75,24.07a3.27,3.27,0,0,1,.91,1.13c.64,1.39-.66,2.1-2.51,2.95a11.83,11.83,0,0,1-2.28.85,1.34,1.34,0,0,0,.07.18c.64,1.4,2.32.73,4.17-.11s3.15-1.56,2.51-2.95A4.11,4.11,0,0,0,765.75,24.07Z"
        fill="#d6974f"
      />
      <ellipse
        cx="852.66"
        cy="35.31"
        rx="1.5"
        ry="4.08"
        transform="translate(563.63 838.27) rotate(-72.57)"
        fill="#e1a554"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        d="M855.07,35.41c-.46,1.46-1.91,1.11-3.84.5s-3.64-1.24-3.18-2.71a4.14,4.14,0,0,1,4.69-2.38A4,4,0,0,1,855.07,35.41Z"
        fill="#eebf57"
      />
      <path
        d="M854.3,32a3.3,3.3,0,0,1-.07,1.45c-.46,1.47-1.9,1.12-3.84.51a11.66,11.66,0,0,1-2.27-.9l-.07.18c-.46,1.47,1.24,2.1,3.18,2.71s3.38,1,3.84-.5A4.15,4.15,0,0,0,854.3,32Z"
        fill="#d6974f"
      />
      <ellipse
        cx="898.79"
        cy="41.06"
        rx="1.5"
        ry="4.08"
        transform="translate(590.45 886.31) rotate(-72.57)"
        fill="#e1a554"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        d="M901.19,41.16c-.46,1.46-1.9,1.11-3.84.5s-3.63-1.24-3.17-2.71a4.13,4.13,0,0,1,4.68-2.38A4,4,0,0,1,901.19,41.16Z"
        fill="#eebf57"
      />
      <path
        d="M900.43,37.71a3.3,3.3,0,0,1-.07,1.45c-.46,1.47-1.91,1.12-3.84.51a11.66,11.66,0,0,1-2.27-.9,1.34,1.34,0,0,0-.07.18c-.46,1.47,1.23,2.1,3.17,2.71s3.38,1,3.84-.5A4.1,4.1,0,0,0,900.43,37.71Z"
        fill="#d6974f"
      />
      <ellipse
        cx="1023.83"
        cy="56.07"
        rx="4.08"
        ry="1.5"
        transform="matrix(1, -0.07, 0.07, 1, -1.37, 74.52)"
        fill="#e1a554"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        d="M1026.1,55.27c.11,1.53-1.36,1.74-3.38,1.89s-3.84.18-4-1.35a4.12,4.12,0,0,1,3.48-3.94A4,4,0,0,1,1026.1,55.27Z"
        fill="#eebf57"
      />
      <path
        d="M1024.12,52.35a3.24,3.24,0,0,1,.47,1.38c.11,1.53-1.36,1.73-3.38,1.88a11,11,0,0,1-2.44,0,1.34,1.34,0,0,0,0,.2c.11,1.53,1.92,1.5,4,1.35s3.49-.36,3.38-1.89A4.1,4.1,0,0,0,1024.12,52.35Z"
        fill="#d6974f"
      />
      <ellipse
        cx="1029.63"
        cy="86.91"
        rx="4.08"
        ry="1.5"
        transform="translate(-3.59 75.03) rotate(-4.17)"
        fill="#e1a554"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        d="M1031.9,86.12c.11,1.53-1.36,1.74-3.38,1.88s-3.84.18-4-1.35a4.12,4.12,0,0,1,3.48-3.94A4,4,0,0,1,1031.9,86.12Z"
        fill="#eebf57"
      />
      <path
        d="M1234.87,224.33c-1.48-1.05-4.08-1-7,.1,1.63,3.49-.16,10.75-5.15,17.82a34.74,34.74,0,0,1-10.43,10.06,4.62,4.62,0,0,0,1.56,2.29c3.37,2.38,11.19-2.65,17.07-11S1238.23,226.71,1234.87,224.33Z"
        fill="#e1a554"
      />
      <path
        d="M1078.61,402.14c-1.44-3.86,4.52-12.33,14.05-15.9s18.93-1.15,20.38,2.71-4.61,10.16-14.15,13.73S1080.05,406,1078.61,402.14Z"
        fill="#f1ce58"
      />
      <path
        d="M1113,389c-.64-1.7-2.82-3.12-5.86-3.87-.62,3.8-6.18,8.8-14.29,11.83a34.81,34.81,0,0,1-14.28,2.46,4.65,4.65,0,0,0,0,2.77c1.44,3.86,10.75,4.1,20.28.54S1114.48,392.81,1113,389Z"
        fill="#e1a554"
      />
      <path
        d="M1210.18,223.11c-1.57-.73-4.07-.14-6.68,1.55a5.11,5.11,0,0,1,3.67-.08c3.34,1.56,3.43,9.36-.4,17.61-2.31,5-5.43,9-8.28,11.07,3.42-.68,8.12-5.73,11.29-12.54C1213.61,232.47,1213.52,224.67,1210.18,223.11Z"
        fill="#e1a554"
      />
      <path
        d="M1211.92,258.13c-1.47-1.48-4.85-1.65-8.67-.36,2.06-.14,3.75.26,4.67,1.19,2.59,2.62,0,10-6.51,16.37a31.66,31.66,0,0,1-10.28,7.05c3.53.11,9.27-2.92,14.28-7.88C1211.88,268.1,1214.51,260.75,1211.92,258.13Z"
        fill="#e1a554"
      />
      <path
        d="M1202.25,294.46c-1.52-1.53-5.09-1.65-9.08-.2a5.78,5.78,0,0,1,4.41,1.2c2.6,2.62,0,10-6.5,16.37a32.7,32.7,0,0,1-9.82,6.88c3.51.24,9.37-2.82,14.49-7.88C1202.21,304.43,1204.84,297.08,1202.25,294.46Z"
        fill="#e1a554"
      />
      <path
        d="M1147,347c-1.61-3.31,3-11.35,11.17-15.32s16.75-2.61,18.36.7-3.25,9.43-11.44,13.4S1148.61,350.36,1147,347Z"
        fill="#f1ce58"
      />
      <path
        d="M1176.53,332.42c-.94-1.94-4.29-3.2-8.53-3.12a5.86,5.86,0,0,1,3.79,2.56c1.61,3.32-3.25,9.43-11.44,13.4a32.44,32.44,0,0,1-11.51,3.34c3.24,1.36,9.78.36,16.25-2.78C1173.28,341.85,1178.14,335.74,1176.53,332.42Z"
        fill="#e1a554"
      />
      <path
        d="M1113.47,376.29c-1.91-3.16,1.93-11.58,9.71-16.29s16.44-4.13,18.35-1-2.38,9.69-10.16,14.39S1115.37,379.44,1113.47,376.29Z"
        fill="#f1ce58"
      />
      <path
        d="M1141.53,359c-1.12-1.84-4.56-2.79-8.79-2.33a5.87,5.87,0,0,1,4,2.21c1.9,3.15-2.38,9.69-10.16,14.39a32.67,32.67,0,0,1-11.16,4.38c3.35,1.06,9.77-.54,15.93-4.26C1139.15,368.71,1143.43,362.18,1141.53,359Z"
        fill="#e1a554"
      />
      <path
        d="M1085.42,367.17c-1.67-3.28,2.77-11.41,10.87-15.54s16.7-2.93,18.37.35-3.07,9.49-11.17,13.62S1087.1,370.45,1085.42,367.17Z"
        fill="#f1ce58"
      />
      <path
        d="M1114.66,352c-1-1.92-4.35-3.12-8.59-3a5.86,5.86,0,0,1,3.84,2.5c1.67,3.28-3.07,9.48-11.17,13.61a32.69,32.69,0,0,1-11.45,3.57c3.27,1.29,9.78.17,16.2-3.1C1111.59,361.47,1116.33,355.26,1114.66,352Z"
        fill="#e1a554"
      />
      <path
        d="M1174.58,292.13c-1.39-1.41-4.5-1.62-8.08-.54,2-.09,3.54.31,4.42,1.21,2.59,2.61,0,10-6.51,16.36a31.11,31.11,0,0,1-10.71,7.22c3.52.17,9.32-2.87,14.38-7.88C1174.55,302.1,1177.18,294.75,1174.58,292.13Z"
        fill="#e1a554"
      />
      <path
        d="M1187.92,260.8c-1.75-1.77-6.22-1.67-10.93.55,3.23-.81,6-.52,7.26.78,2.59,2.62,0,10-6.5,16.37a33.92,33.92,0,0,1-8.66,6.34c3.49-.76,8.15-3.55,12.32-7.68C1187.88,270.76,1190.51,263.41,1187.92,260.8Z"
        fill="#e1a554"
      />
      <ellipse
        cx="1220.74"
        cy="273.02"
        rx="5.4"
        ry="1.98"
        transform="translate(69.1 761.35) rotate(-35.59)"
        fill="#e1a554"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        d="M1222.75,270.55c1.18,1.65-.34,2.9-2.52,4.46s-4.21,2.85-5.39,1.2a5.46,5.46,0,0,1,1.22-6.85C1218.24,267.8,1221.57,268.9,1222.75,270.55Z"
        fill="#eebf57"
      />
      <path
        d="M1218.51,268.62a4.29,4.29,0,0,1,1.47,1.23c1.18,1.65-.34,2.9-2.52,4.46a15.54,15.54,0,0,1-2.75,1.68c0,.08.09.15.13.22,1.18,1.65,3.21.37,5.39-1.2s3.7-2.81,2.52-4.46A5.38,5.38,0,0,0,1218.51,268.62Z"
        fill="#d6974f"
      />
      <ellipse
        cx="1245.11"
        cy="230.24"
        rx="4.1"
        ry="1.51"
        transform="translate(98.54 767.54) rotate(-35.59)"
        fill="#e1a554"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        d="M1246.64,228.37c.89,1.25-.26,2.2-1.92,3.39s-3.2,2.16-4.09.91a4.14,4.14,0,0,1,.92-5.2A4,4,0,0,1,1246.64,228.37Z"
        fill="#eebf57"
      />
      <path
        d="M1243.41,226.9a3.26,3.26,0,0,1,1.12.93c.9,1.26-.26,2.21-1.92,3.39a10.62,10.62,0,0,1-2.09,1.28c0,.06.07.12.11.17.89,1.25,2.43.28,4.09-.91s2.81-2.14,1.92-3.39A4.12,4.12,0,0,0,1243.41,226.9Z"
        fill="#d6974f"
      />
      <ellipse
        cx="1206.88"
        cy="286.37"
        rx="5.88"
        ry="2.16"
        transform="translate(58.74 755.78) rotate(-35.59)"
        fill="#e1a554"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        d="M1209.08,283.68c1.28,1.8-.37,3.16-2.75,4.87s-4.59,3.1-5.87,1.3-1.06-5.76,1.32-7.46S1207.79,281.89,1209.08,283.68Z"
        fill="#eebf57"
      />
      <path
        d="M1204.45,281.57a4.83,4.83,0,0,1,1.61,1.35c1.28,1.79-.37,3.15-2.75,4.86a16.91,16.91,0,0,1-3,1.83,1.94,1.94,0,0,0,.15.24c1.28,1.8,3.49.4,5.87-1.3s4-3.07,2.75-4.87A6,6,0,0,0,1204.45,281.57Z"
        fill="#d6974f"
      />
      <path
        d="M1080.23,376.67c-.37-2.61-3.4-5.3-8-7.07a6,6,0,0,1,1.62,3.07c.72,5.05-8.28,11.08-20.78,12.87-6.73,1-13.09.6-17.64-.73,2.31,4.21,12.61,6.36,24,4.73C1072,387.75,1081,381.72,1080.23,376.67Z"
        fill="#e1a554"
      />
      <path
        d="M1067.08,402.77c-.42-2.93-5.51-6-12.18-6.46,3.34,1.27,5.58,3.23,5.85,5.13.52,3.64-6,8-15,9.28a37.09,37.09,0,0,1-7.85.3c3.29,1.36,8.55,1.84,14.18,1C1061.11,410.76,1067.6,406.42,1067.08,402.77Z"
        fill="#e1a554"
      />
      <g>
        <path
          d="M1108.88,333.53c-.61-4.22,7.57-11.49,18.32-13s20,2.94,20.57,7.15-7.16,9.27-17.92,10.81S1109.48,337.74,1108.88,333.53Z"
          fill="#f1ce58"
        />
        <path
          d="M1147.77,327.65c-.39-2.7-4.31-5.49-9.9-6.76,2.53,1.37,4.16,3.08,4.4,4.76.6,4.21-7.16,9.27-17.92,10.81a41.48,41.48,0,0,1-13.38-.12c3.5,2.3,10.88,3.27,18.88,2.12C1140.61,336.92,1148.37,331.86,1147.77,327.65Z"
          fill="#e1a554"
        />
      </g>
      <g>
        <ellipse
          cx="1074.95"
          cy="414.18"
          rx="1.85"
          ry="5.03"
          transform="translate(649.05 1484.55) rotate(-89.37)"
          fill="#e1a554"
          style={{ mixBlendMode: 'multiply' }}
        />
        <path
          d="M1077.82,413.44c0,1.89-1.85,2-4.35,2s-4.74-.18-4.72-2.07a5.1,5.1,0,0,1,4.69-4.49C1075.94,408.88,1077.84,411.55,1077.82,413.44Z"
          fill="#eebf57"
        />
        <path
          d="M1075.7,409.64a4.16,4.16,0,0,1,.43,1.74c0,1.89-1.86,2-4.36,2a14.19,14.19,0,0,1-3-.25,1.94,1.94,0,0,0,0,.24c0,1.89,2.21,2,4.72,2.07s4.33-.08,4.35-2A5.05,5.05,0,0,0,1075.7,409.64Z"
          fill="#d6974f"
        />
      </g>
      <g>
        <ellipse
          cx="1070.04"
          cy="364.3"
          rx="0.98"
          ry="2.67"
          transform="translate(694.08 1430.3) rotate(-89.37)"
          fill="#e1a554"
          style={{ mixBlendMode: 'multiply' }}
        />
        <path
          d="M1071.57,363.9c0,1-1,1.06-2.31,1.05s-2.51-.1-2.5-1.1a2.7,2.7,0,0,1,2.48-2.38A2.6,2.6,0,0,1,1071.57,363.9Z"
          fill="#eebf57"
        />
        <path
          d="M1070.44,361.89a2.19,2.19,0,0,1,.23.92c0,1-1,1.06-2.31,1.05a7.52,7.52,0,0,1-1.59-.14.62.62,0,0,0,0,.13c0,1,1.17,1.08,2.5,1.1s2.29,0,2.31-1.05A2.72,2.72,0,0,0,1070.44,361.89Z"
          fill="#d6974f"
        />
      </g>
      <g>
        <ellipse
          cx="1120.76"
          cy="386.58"
          rx="1.59"
          ry="4.32"
          transform="translate(721.97 1503.05) rotate(-89.37)"
          fill="#e1a554"
          style={{ mixBlendMode: 'multiply' }}
        />
        <path
          d="M1123.23,385.94c0,1.62-1.59,1.71-3.74,1.69s-4.07-.15-4-1.78a4.35,4.35,0,0,1,4-3.85A4.2,4.2,0,0,1,1123.23,385.94Z"
          fill="#eebf57"
        />
        <path
          d="M1121.4,382.67a3.6,3.6,0,0,1,.37,1.5c0,1.62-1.59,1.71-3.74,1.69a11.76,11.76,0,0,1-2.58-.22,1.48,1.48,0,0,0,0,.21c0,1.63,1.89,1.75,4,1.78s3.72-.07,3.74-1.69A4.36,4.36,0,0,0,1121.4,382.67Z"
          fill="#d6974f"
        />
      </g>
      <path
        d="M1025.92,74.4c-2,3.74-10.52.88-19.76-4s-15.84-9.77-13.85-13.51,11-3.37,20.21,1.55S1027.92,70.66,1025.92,74.4Z"
        fill="#f1ce58"
      />
      <path
        d="M1025.92,74.4c.67-1.25.41-2.91-.56-4.74-2.75,2.51-10.65-.26-19.16-4.8-5.94-3.16-10.77-6.28-13-9.11a3.77,3.77,0,0,0-.94,1.1c-2,3.74,4.61,8.59,13.85,13.51S1023.93,78.14,1025.92,74.4Z"
        fill="#e1a554"
      />
      <path
        d="M1066.82,79.45c-2,3.74-10.52.87-19.76-4s-15.84-9.76-13.85-13.5,11-3.37,20.21,1.55S1068.81,75.71,1066.82,79.45Z"
        fill="#f1ce58"
      />
      <path
        d="M1066.82,79.45c.66-1.26.4-2.91-.57-4.75-2.74,2.52-10.64-.25-19.16-4.79-5.93-3.16-10.76-6.29-12.94-9.11a3.51,3.51,0,0,0-.94,1.1c-2,3.74,4.6,8.58,13.85,13.5S1064.83,83.19,1066.82,79.45Z"
        fill="#e1a554"
      />
      <path
        d="M1062.79,98c-1.52,2.67-7.64.43-14.24-3.32s-11.28-7.39-9.77-10.06,8-2.22,14.61,1.52S1064.3,95.37,1062.79,98Z"
        fill="#f1ce58"
      />
      <path
        d="M1062.79,98c.52-.92.34-2.16-.37-3.54-1.94,2-7.71-.24-13.9-3.76-4.18-2.37-7.58-4.7-9.14-6.77a2.79,2.79,0,0,0-.6.69c-1.51,2.67,3.17,6.31,9.77,10.06S1061.27,100.71,1062.79,98Z"
        fill="#e1a554"
      />
      <path
        d="M1091.76,99.15c-1.52,2.67-7.64.43-14.24-3.32s-11.28-7.39-9.77-10.06,8-2.22,14.61,1.52S1093.27,96.48,1091.76,99.15Z"
        fill="#f1ce58"
      />
      <path
        d="M1091.76,99.15c.52-.92.34-2.16-.37-3.54-1.94,2-7.71-.24-13.9-3.76-4.18-2.37-7.58-4.7-9.14-6.77a2.79,2.79,0,0,0-.6.69c-1.51,2.67,3.17,6.31,9.77,10.06S1090.24,101.82,1091.76,99.15Z"
        fill="#e1a554"
      />
      <path
        d="M1092.46,121c-1.52,2.67-7.64.43-14.24-3.32s-11.29-7.38-9.77-10.06,8-2.22,14.61,1.53S1094,118.32,1092.46,121Z"
        fill="#f1ce58"
      />
      <path
        d="M1092.46,121c.52-.91.34-2.16-.37-3.54-1.94,2-7.71-.24-13.9-3.76-4.18-2.37-7.58-4.69-9.14-6.76a2.58,2.58,0,0,0-.6.68c-1.52,2.68,3.17,6.32,9.77,10.06S1090.94,123.66,1092.46,121Z"
        fill="#e1a554"
      />
    </g>
  );
};

export default Trope3;
